module.exports = __webpack_public_path__ + "img/玫瑰.12b9d6df.svg";